export default "__VITE_PUBLIC_ASSET__144a5f61__"